import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tracks a page view, video play, or photo view event.
 * Lightweight, fire-and-forget — never blocks UI.
 */
export function trackEvent(eventType, data = {}) {
  const params = new URLSearchParams(window.location.search);
  const payload = {
    event_type: eventType,
    page: window.location.pathname,
    referrer: document.referrer || '',
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    ...data,
  };

  // Fire and forget — don't await, don't block
  axios.post(`${API_URL}/api/analytics/track`, payload).catch(() => {});
}

export function trackPageView(profileSlug) {
  trackEvent('page_view', { profile_slug: profileSlug });
}

export function trackVideoPlay(profileSlug, videoId) {
  trackEvent('video_play', { profile_slug: profileSlug, video_id: videoId });
}

export function trackPhotoView(profileSlug) {
  trackEvent('photo_view', { profile_slug: profileSlug });
}
